export default class Perfilinvestigationcontroller{

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, i18nService){ 
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.perfilSrv = perfilSrv;
        this.userinfo = null;
        this.$scope.chartConfig = {};
        this.$cookies = $cookies;
        this.$scope.gridOptionsComplex = {
            enableFiltering: true,
            enableGridMenu: true,
            showFooter: true,
            rowHeight: 36,
            columnDefs: [
                { displayName: 'Tipo de publicación',field:'tipoDePublicacion', width: '25%' },
                { displayName: 'Año de publicación',field:'anoDePublicacion', width: '25%' },
                { displayName: 'Subtipo',field:'subTipo', width: '20%' },
                { displayName: 'Título',field:'titulo', width: '20%' }
            ]
        };
        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
        i18nService.setCurrentLang('es')
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.PerfildeInvestigacion(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.PerfildeInvestigacion(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    PerfildeInvestigacion(teacherId) {
        this.perfilSrv.perfildocente.PerfildeInvestigacion({teacherId:teacherId}).$promise.then((dataReturn) => {
            this.$scope.gridOptionsComplex.data = dataReturn.data;
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

}

Perfilinvestigationcontroller.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'i18nService'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/perfil_investigation/Perfilinvestigationcontroller.js